import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { NavigationExtras, Router } from '@angular/router';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { ProductService, ProductSpec } from 'src/app/services/api/product/product.service';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';

@Component({
  selector: 'app-catalog-search',
  templateUrl: './catalog-search.component.html',
  styleUrls: ['./catalog-search.component.scss']
})
export class CatalogSearchComponent implements OnInit {

  @ViewChild(MatPaginator, null) paginator: MatPaginator;
  @ViewChild(MatSort, null) sort: MatSort;

  displayedColumns: string[] = [
    'name', 'version'
  ];
  dataSource: MatTableDataSource<ProductSpec>;

  constructor(private router: Router, private productService: ProductService,
    private breadcrumbsService: BreadcrumbsService, private notificationsService: NotificationsService) {

  }

  ngOnInit() {
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs: [
          { title: 'Administración', url: 'provision/management' },
          { title: 'Catálogo', url: 'provision/management/catalog' },
          { title: 'Asociación de catálogo', url: 'provision/management/search' },
        ]
      });

    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 10;
    this.sort.active = 'name';
    this.sort.direction = 'desc';

    this.dataSource = new MatTableDataSource();
    this.submitForm(false);
  }

  submitForm(paginate: boolean) {
    const DATA: any[] = [];
    this.productService.getPaginatedProductSpecs(this.paginator.pageIndex.toString(),
      this.paginator.pageSize.toString(),
      this.sort.active ? this.sort.active + ',' + this.sort.direction : null
    ).subscribe(
      (data) => {
        for (const productSpec of data._embedded.productSpecs) {
          DATA.push(productSpec);
        }
        this.dataSource.data = DATA;
        this.paginator.length = data.page.totalElements;
        if (!paginate) {
          this.paginator.firstPage();
        }
      },
      (error) => {
        this.notificationsService.showNotification(
          'Ha habido un problema al recuperar los productos del catálogo',
          NotificationLevel.ERROR);
      }
    );
  }

  public goToProductSpec(productSpec: any): void {

    const navigationExtras: NavigationExtras = {
      queryParams: {
        name: productSpec.name,
      }
    };

    this.router.navigate(['/provision/management/catalog/detail'], navigationExtras);

  }

}
